import React from 'react';

function UserReviewPage() {
    return <div className="col-12 col-lg-9 col-xl-9 col-md-9">UserReviewPage</div>;
}

export default UserReviewPage;
